import React, { useState } from 'react';
import Footer from './Footer';
import FeedbackModal from './modals/FeedbackModal';
import ContactModal from './modals/ContactModal';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div className="min-h-screen w-full px-0 md:px-4 mobile:px-0 bg-gray-50">
      {children}
      <Footer 
        onFeedbackClick={() => setShowFeedbackModal(true)}
        onContactClick={() => setShowContactModal(true)}
      />
      <FeedbackModal
        isOpen={showFeedbackModal}
        onClose={() => setShowFeedbackModal(false)}
      />
      <ContactModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </div>
  );
}
